module.exports = {
  siteName: "BloFin",
  siteNameLower: "blofin",
  messagesDir: "messages",
  defaultLogo: "https://s2.blofin.com/static/currency/icon/default-v3.png",
  ratingWidgetTag: "blofin-rating-widget",
  ratingWidgetScript:
    "https://s2.tokeninsight.com/widgets/blofin-rating-widget/index.js",
  libraryPath: "https://s2.blofin.com/sdk/charting_library2/",
  customCssUrl: "https://s2.blofin.com/sdk/css/chart.css",
  cssCustomProperty: {
    "--tv-color-toolbar-button-text-active": "#FF8800",
    "--tv-color-toolbar-button-text-active-hover": "#FF8800",
    "--tv-color-popup-element-text-active": "#050505",
    "--tv-color-popup-element-background-active": "#FF8800",
  },
  css: {
    primary: "#FF8800",
  },
  echartLibraryPath: "https://s2.blofin.com/sdk/echarts.min.js",
  aboutURL: {
    liquidation:
      "https://blofin.zendesk.com/hc/articles/6228098318991-How-to-calculate-the-liquidation-price-What-are-the-conditions-for-the-margin-call-",
    partial_liquidation:
      "https://blofin.zendesk.com/hc/articles/6228098318991-How-to-calculate-the-liquidation-price-What-are-the-conditions-for-the-margin-call-",
    adl: "https://blofin.zendesk.com/hc/articles/6228151916175-What-Is-Auto-Deleveraging-ADL-and-How-Does-It-Work-",
  },
  orderTypeTooltip: {
    market:
      "https://blofin.zendesk.com/hc/en-us/articles/8787728354703-What-is-a-Market-Order-",
    limit:
      "https://blofin.zendesk.com/hc/en-us/articles/8787722019471-What-is-Limit-order-",
    trigger:
      "https://blofin.zendesk.com/hc/en-us/articles/8787669701263-What-is-a-Trigger-Order-",
  },
  requestHeader: "blofin-copy-trading-user",
  domain: "https://blofin.com",
  s2Domain: "https://s2.blofin.com",
  webpushAppkey: "0dcca73f2d7007326102c3a8",
  zendeskID: "2a42d5dd-9844-4f34-b2a8-6aa090afb7e9",
  //! LOGO 地址更换需要周知安全，防火墙上有路径限制，更换路径会导致爬虫失效
  favicon: "https://s2.blofin.com/icons/blofin/favicon-v3.ico",
  dynamicNavUrl: "https://s2test.blofin.com/sdk/nav/entry.js",
  apiDomain: "https://api.blofin.com",
  wsDomain: "wss://ws-public.blofin.com/websocket",
  wsPrivateDomain: "wss://ws-private.blofin.com/websocket",
  webPushSdkUrl: "https://s2.blofin.com/sdk/webSdk.produce.min.3.0.0.js",
  sensorsDataServerUrl: "https://beacon-log-server.blofin.com",
  seoImagePath: "/seo/en.jpeg",
  sensorsDataServerUrlDev: "https://beacon-log-server-dev.blofin.com",
  securityZendeskUrl:
    "https://blofin.zendesk.com/hc/en-us/articles/10081612570511-How-to-Create-a-Passkey-Web",
  riskWarningOverloadUrl:
    "https://support.blofin.com/hc/en-us/articles/7298206673423-RISK-DISCLOSURE-STATEMENT",
  emailSupport: "mailto:support@blofin.com",
  emailMsg: "blofin@blofin.com",
  telegramHref: "https://t.me/BloFin_Official",
  xHref: "https://x.com/Blofin_Official",
  accountTransferFaqUrl: {
    more: "https://blofin.zendesk.com/hc/${lang}/categories/7337929824655-FAQ",
    transferFaq1:
      "https://blofin.zendesk.com/hc/${lang}/articles/11350707438095-How-Do-I-Transfer-My-Crypto-Into-My-Sub-account",
    transferFaq2:
      "https://support.blofin.com/hc/${lang}/articles/6228358793231-What-is-BloFin-Futures-Bonus-and-How-does-it-Work",
    transferFaq3:
      "https://support.blofin.com/hc/${lang}/articles/11041664795151-Unified-Trading-Account-Guide",
  },
  affiliateEmail: "mailto:affiliate@blofin.com",
  seoImagePathRegister: "/seo/register.jpeg",
  turnstileSiteKey: "0x4AAAAAAAFqaqYE4BDlAyAC",
  appSchema: "blofin://openapp",
  downloadName: "blofin.png",
  appleAppId: "1616804346",
  appStoreUrl: "https://apps.apple.com/tt/app/blofin/id1616804346",
  googlePlayUrl:
    "https://play.google.com/store/apps/details?id=com.blofin.android",
  downloadQrcodeUrl: "https://s2.blofin.com/frontend-images/dl-qr-light-v3.png",
  apkUrl: (country) => "https://blofin.com/download/blofin.apk",
  adjustBalance:
    "https://support.blofin.com/hc/en-us/articles/9876871943183-BloFin-Futures-Bonus-What-Is-It-and-How-Does-It-Work",
};
